<template>
  <!--<div class="transactions-container"> -->
  <div class="w3-row-padding">
    <div class="w3-col">
      <h1>{{ $t("menu.transactions") }}</h1>
      <h4>{{ $t("transactions.pageDesc") }}</h4>
      <div class="w3-card">

        <div style="padding-bottom: 10px">
          <label for="transactionInput">
            {{ $t("transactions.transactions") }}
            <i id="trtippy" class="far fa-question-circle" />
          </label>
          <div v-if="errorMessage != ''">{{ $t(errorMessage) }}</div>
          <input id="transactionInput" v-model="transactionString" :placeholder="$t('transactions.placeholder')"
            autocomplete="off" autofocus maxlength="100" required class="w3-input" type="text" @keyup.enter="send" />
          <hr />
        </div>

        <div class="transactions-table w3-responsive">
          <!-- <table class="w3-table w3-bordered w3-striped w3-hoverable">
            <thead>
              <tr>
                <th scope="col">
                  {{ $t("transactions.description") }}
                </th>
                <th scope="col">
                  {{ $t("transactions.value") }}
                </th>
                <th scope="col">
                  {{ $t("transactions.date") }}
                </th>
                <th scope="col">
                  {{ $t("transactions.action") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tr, index) in transactions" :key="index">
                <td v-if="!editMode(index)">
                  {{ tr.desc }}
                </td>
                <td v-else>
                  <input id="trupdate" v-model="tr.desc" type="text" name="trupdate" @keyup.enter="update(tr.id, index)"
                    @keyup.esc="edit(index)" />
                </td>
                <td v-if="!editMode(index)">
                  {{ moneyFormat(tr.value) }}
                </td>
                <td v-else>
                  <input id="trvalue" v-model="tr.value" type="number" name="trvalue"
                    @keyup.enter="update(tr.id, index)" @keyup.esc="edit(index)" />
                </td>
                <td v-if="!editMode(index)">
                  {{ dateFormat(tr.created_at) }}
                </td>
                <td v-else>
                  <input id="trdate" v-model="tr.created_at" type="date" name="trdate"
                    @keyup.enter="update(tr.id, index)" @keyup.esc="edit(index)" />
                </td>
                <td class="td-delete">
                  <i class="far fa-edit tr-delete" style="margin-right: 5px" @click="edit(index)" />
                  <i class="far fa-trash-alt tr-delete" @click="deleteTransaction(tr.id, index)" />
                </td>
              </tr>
            </tbody>
          </table> -->
        </div>
        <div class="w3-responsive">
          <v-data-table-server :sticky="true" v-model:items-per-page="itemsPerPage" :headers="headers"
            v-model:page="currentPage" :items="transactions" :items-length="totalPages" item-value="id"
            :loading="loading" @update:options="loadData">
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <span v-show="!item.editMode">{{ item.desc }}</span>
                  <span v-show="item.editMode">
                    <input
                      type="text"
                      v-model="item.desc"
                      @keyup.enter="update(item)"
                      />
                  </span>
                </td>
                <td>
                  <span v-show="!item.editMode">{{ moneyFormat(item.value) }}</span>
                  <span v-show="item.editMode">
                    <input
                      type="number"
                      v-model="item.value"
                      @keyup.enter="update(item)"
                      />
                  </span>
                </td>
                <td>
                  <span v-show="!item.editMode">{{ item.created_at }}</span>
                  <span v-show="item.editMode">
                    <input
                      type="date"
                      v-model="item.created_at"
                      @keyup.enter="update(item)"
                      />
                  </span>
                </td>
                <td>
                  <v-icon class="me-2" size="small" @click="item.editMode ? update(item) : edit(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon size="small" @click="deleteTransaction(item)">
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import Transactions from "../apiClient/transactions/index.js";
import Formatter from "../utils/formatters.js";

export default {
  name: "Transactions",
  data: function () {
    return {
      transactions: [],
      transactionString: "",
      errorMessage: '',
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 0,
      loading: true,
      headers: [{
        title: this.$t("transactions.description"),
        align: 'start',
        sortable: true,
        key: 'desc',
      },
      {
        title: this.$t("transactions.value"),
        sortable: true,
        key: 'value',
      },
      {
        title: this.$t("transactions.date"),
        sortable: true,
        key: 'created_at',
      },
      {
        title: this.$t("transactions.action"),
        sortable: false,
        key: 'actions',
      },
      ]
    };
  },
  mounted() {
    this.loadData()
    let content = this.$t("transactions.tooltip");
    this.tippy("#trtippy", {
      content: content,
      trigger: "click",
    });
  },
  methods: {
    loadData(options) {
      if (!options) {
        return
      }
      this.loading = true
      var self = this
      //console.log(options); { page: options.page, page_size: options.itemsPerPage }
      Transactions.get({ page: options.page, page_size: options.itemsPerPage }).then(function (data) {
        self.transactions = data.data;
        self.totalPages = data.total_pages
        for (var i = 0; i < self.transactions.length; i++) {
          self.transactions[i]["created_at"] = Formatter.date(self.transactions[i]["created_at"])
        }
        self.loading = false
      });
    },
    send() {
      if (!this.transactionString) {
        this.errorMessage = 'empty_transaction'
        return;
      }
      var self = this;
      Transactions.post({ transactionString: this.transactionString })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.message) {
            self.errorMessage = data.message
          } else {
            self.errorMessage = ''
            self.transactionString = "";
            data.created_at = Formatter.date(data.created_at);
            self.transactions.unshift(data);
            self.emitter.emit("UpdateCurrentCash");
          }
        })
    },
    update(item) {
      var self = this;
      const { id, desc, value, created_at } = item;
      const updatedItem = {
        id,
        desc,
        value,
        created_at // Explicitly including date to ensure backend update
      }
      Transactions.put(id, { transaction: updatedItem }).then(
        function () {
          item.editMode = false;
          self.emitter.emit("UpdateCurrentCash");
        }
      );
    },
    moneyFormat: Formatter.money,
    dateFormat: Formatter.date,
    deleteTransaction(transaction) {
      var self = this;
      //const indexToRemove = self.transactions.findIndex((e) => e.id == transaction.id)
      //self.transactions.splice(indexToRemove, 1)
      Transactions.remove(transaction.id).then(function () {
        self.emitter.emit("UpdateCurrentCash");
        self.loadData({page: self.currentPage})
      });
    },
    editMode(index) {
      return this.transactions[index].editMode;
    },
    edit(index) {
      index.editMode = !index.editMode
      //this.transactions[index].editMode = !this.transactions[index].editMode;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.transactions-container {
  background-color: white;
  padding: 1rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 15px;
}

.transactions-table {
  max-height: 71vh;
  overflow-y: scroll;
}
</style>
